module.exports = __webpack_public_path__ + "assets/img/官网首页_09.3d891a21.jpg";